import * as React from "react";
import { colors, ThemeProvider as MuiThemeProvider, StyledEngineProvider, Theme } from "@mui/material";
import { createTheme, darken } from "@mui/material/styles";
import { red } from "@mui/material/colors";
import { Colors } from "../styles";
import { State } from "../types";
import { connect } from "react-redux";

const lightTheme: Theme = createTheme({
    palette: {
        mode: "light",
        primary: {
            main: Colors.Deverto,
            dark: darken(Colors.Deverto, 0.2),
        },
        secondary: {
            main: red[700],
        },
    },
});

const darkTheme: Theme = createTheme({
    palette: {
        mode: "dark",
        primary: {
            main: Colors.Deverto,
        },
        secondary: {
            main: colors.red[900],
        },
        background: {
            default: colors.grey[900],
            paper: colors.grey[800],
        },
    },
});

type StateProps = Pick<State, "theme">;

const mapStateToProps = (state: State): StateProps => state;

const ThemeProvider = ({ children, theme }: { children: React.ReactNode } & StateProps) => {
    return (
        <StyledEngineProvider injectFirst>
            <MuiThemeProvider theme={theme === "light" ? lightTheme : darkTheme}>{children}</MuiThemeProvider>
        </StyledEngineProvider>
    );
};

export default connect(mapStateToProps)(ThemeProvider);
